/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Virtual Voice Manager" |
*
* @param {Voice_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_title = /** @type {((inputs?: Voice_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de voix virtuelles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Virtueller Sprachmanager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestore vocale virtuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Виртуальный голосовой менеджер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de voz virtual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("虚拟语音管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("仮想音声マネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्चुअल वॉयस मैनेजर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de Voz Virtual")
	return /** @type {LocalizedString} */ ("Virtual Voice Manager")
});